<template>
  <Record
    class="RecordLaptopFlagged"
    :title="laptop.name">
    <Row>
      <Column :lg="6">
        <LaptopImage :laptop="laptop" />
      </Column>
      <Column :lg="6">
        <Row>
          <Column :xs="12">
            <Set icon="info" :label="$t('articleCount')">
              {{ laptopGroup.articleLaptopIds.length }}
            </Set>
          </Column>
          <Column :xs="12">
            <Set icon="info" :label="$t('price')">
              {{ laptop.price ? `$${laptop.price}` : `${$t('unavailable') }` }}
            </Set>
          </Column>
          <Column :xs="12">
            <Set icon="link" :label="laptop.asin">
              <a :href="formAmazonLink(laptop.asin)">
                {{ $t('link') }}
              </a>
            </Set>
          </Column>
        </Row>
      </Column>
    </Row>
    <div slot="actions" class="actionsWithTags">
      <Route
        :id="laptopGroup.laptopId"
        class="Btn ib sm info inv"
        to="Laptop">
        {{ $t('linkToLaptop') }}
      </Route>
      <Route
        :id="laptopGroup.laptopId"
        class="Btn ib sm info"
        to="LaptopFlagged">
        {{ $t('viewArticles') }}
      </Route>
    </div>
  </Record>
</template>

<script>
import LaptopImage from '@components/LaptopImage'
import { getters } from '@utils'

export default {
  components: { LaptopImage },
  props: {
    isChecked: Boolean,
    laptopGroup: Object,
  },
  computed: {
    laptop() {
      return this.queryOne('laptop', this.laptopGroup.laptopId)
    },
    ...getters('formAmazonLink'),
  },
}
</script>

<style lang="scss">
.RecordLaptopFlagged {
  .LaptopImage {
    img {
      height: 10rem;
      object-fit: contain;
      width: 100%;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "link": "View on Amazon",
    "articleCount": "Articles count",
    "price": "Price",
    "linkToLaptop": "Go to laptop",
    "viewArticles": "View articles",
    "unavailable": "Unavailable"
  }
}
</i18n>
